import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import { StatusOptionsDocuments } from "../../../types/FilterEnums";
import { statusCellStyle } from "../../trips/style";
import documentsIcon from "../../../assets/images/icons/documentsGridIcon.svg";
import { UploadSharp } from "@mui/icons-material";
interface StatusCellRendererProps {
  value: StatusOptionsDocuments | null;
}

const StatusCellRendererDocuments: React.FC<StatusCellRendererProps> = ({ value }) => {
  const getStatusData = (status: StatusOptionsDocuments | null) => {
    switch (status) {
      case StatusOptionsDocuments.PROFILO_PARZIALE:
      case StatusOptionsDocuments.IN_GESTIONE:
      case StatusOptionsDocuments.IN_VERIFICA:
        return {
          text: "To be evaluated",
          icon: <AccessTimeIcon sx={{ color: "#FFC107", }} />,
        };
      case null:
        return {
          text: "To be uploaded",
          icon: <UploadSharp sx={{ color: "#2196F3", }} />,
        };
      case StatusOptionsDocuments.ACCEPTED1:
      case StatusOptionsDocuments.ACCEPTED2:
      case StatusOptionsDocuments.GESTITO:
      case StatusOptionsDocuments.VALID:

        return {
          text: "Accepted",
          icon: <CheckCircleIcon sx={{ color: "#4CAF50", }} />,
        };
      case StatusOptionsDocuments.REJECTED:
      case StatusOptionsDocuments.ERROR:

        return {
          text: "Rejected",
          icon: <BlockIcon sx={{ color: "#F44336", }} />,
        };
      default:
        return {
          text: "To be uploaded",
          icon: <UploadSharp sx={{ color: "#2196F3", }} />,
        };
    }
  };
  
  const { text, icon,  } = getStatusData(value);

  return (
    <Box
     sx={{display:'flex', flexDirection:'row', justifyContent:'flex-start', alignItems:'center', columnGap:'8px', }}
    >
      {icon}
      <Typography variant="body2">{text}</Typography>
    </Box>
  );
};

export default StatusCellRendererDocuments;
